export class UserPdfSynopse {
  idSynopseListe: Number[] = [];
  downloadAllInOne!: boolean;
}
